var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":"","width":"870"}},[_c('div',{staticClass:"header"},[_c('img',{attrs:{"src":_vm.logo}}),_c('div',{staticClass:"header-text"},[_vm._v("International Feedback Management")])]),_c('div',{staticClass:"ma-4"},[_vm._t("default")],2),_c('div',{staticClass:"footer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }